import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import PropTypes from 'prop-types'

import { getConfig } from 'src/features/config/ConfigSelector'
import { getCurrentYear } from 'src/utils'

import Page from 'src/components/Page'
import { OngageHeader, OngageFooter } from 'appdev-ui-library'

import styles from './layout.module.sass'

const Layout = ({ children }) => {
  const menuConfig = useSelector(getConfig('menus'))
  const footer = menuConfig?.footer || []
  const { menu_items } = footer

  // Hide elements causing a blank space in the bottom
  useEffect(() => {
    document
      .querySelectorAll('label[for^="rvid_"]')
      .forEach(el => el.style.setProperty('display', 'none', 'important'))

    document
      .querySelectorAll('input[id^="rvid_"]')
      .forEach(el => el.style.setProperty('display', 'none', 'important'))
  }, [])

  const siteLinks = menu_items
    .map(item =>
      !['About FirstWord', 'Advertise With Us'].includes(item.label)
        ? {
            label: item.label,
            href: item.to
          }
        : null
    )
    .filter(item => item !== null)

  return (
    <Page simplePage className={styles.mainContainer}>
      <OngageHeader logo="firstWordGroupLogo" />
      <div className={styles.contentContainer}>{children}</div>
      <OngageFooter
        logo="firstWordGroupFooter"
        footerTextColor="#FFFFFF"
        footerBackgroundColor="#2d3e50"
        borderBottomWidth="1px"
        borderBottomColor="#FFFFFF"
        separatorColor="#FFFFFF"
        copyrightText={`© ${getCurrentYear()} FirstWord. All rights reserved`}
        addressText="1140 Avenue of the Americas, 14th Floor, New York, NY 10036"
        links={siteLinks}
      />
    </Page>
  )
}

Layout.propTypes = {
  /**
   * The content to display inside the layout.
   */
  children: PropTypes.node
}

export default Layout
